module.exports = __webpack_public_path__ + "img/trading-view.36594b2c.png";